import {useRef} from "react";
import { cn } from "@/lib/utils";

interface DropdownInputProps {
  query: string;
  setQuery: (data: string) => void;
  selectedData: any;
  inputIsFocused: boolean;
  setInputIsFocused: (data: boolean) => void;
  placeholder: string;
  icon: any;
  name?: string;
}

export default function DropdownInput(props: DropdownInputProps) {
  const {
    setInputIsFocused,
    inputIsFocused,
    query,
    setQuery,
    selectedData,
    placeholder,
  } = props;
  const serviceInputRef = useRef<HTMLInputElement>(null);

  return (
    <div
      onClick={() => serviceInputRef.current?.focus()}
      className={cn(
        "py-2 h-14 w-full rounded-[20px] duration-200 border px-4 gap-2 flex justify-between items-center shadow-lg border-slate-300",
      )}
    >
      <div
        className={cn(
          "!h-9 flex duration-200 justify-center items-center text-2xl text-white",
        )}
      >
        <props.icon
          className={cn(
            "size-5",
            !inputIsFocused ? "text-assistant" : "text-primary",
          )}
        />
      </div>

      <div className="flex flex-col px-2 w-full duration-200 py-[4.5px]">
        <label
          className={cn(
            "font-bold duration-200 text-primary text-base h-[21px]",
            !selectedData?.title ? "text-gray-400" : "text-gray-400 text-xs",
          )}
        >
          {placeholder}
        </label>

        <input
          ref={serviceInputRef}
          type="text"
          value={query}
          onChange={(e: ReactEvents.ChangeEvent<HTMLInputElement>) => {
            setQuery(e.target.value as string);
          }}
          onFocus={() => {
            setInputIsFocused(!inputIsFocused);
          }}
          className={cn(
            "text-primary duration-200 w-full outline-none font-bold text-base",
            inputIsFocused || selectedData?.title
              ? "h-[21px] opacity-100"
              : "h-[0px] opacity-0",
          )}
          name={props.name}
        />
      </div>
    </div>
  );
}
